import Logger from 'js-logger';

Logger.useDefaults({
    defaultLevel: Logger.ERROR,
    formatter: function (messages, context) {
        messages.unshift(context.name, new Date().toUTCString());
    }
});

const logger = Logger.get('Logger');

export { logger };
